<template>
    <div v-if="firstRendered">
        <div class="filter-condition box-shadow-small border-radius">
            <multi-search class="salary-search" ref="MultiSearch" :key="$route.params.id" :fields="multiFields" @clear="handleClear"></multi-search>
        </div>
        <div class="filter-result background-white box-shadow-small border-radius">
            <div class="filter-result-header mt-15 clearfix">
                <el-row type="flex" justify="space-between">
                    <el-col :span="12">
                        <el-dropdown class="mr-5">
                            <el-button type="primary">批量操作<i class="el-icon-caret-bottom el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <!--<el-dropdown-item @click.native="multiChangePosition(idStr)">批量修改职位</el-dropdown-item>-->
                                <el-dropdown-item @click.native="syncToSupplier(idStr)">批量同步供应商</el-dropdown-item>
                                <el-dropdown-item @click.native="sendEmail(idStr)">批量发送定薪通知</el-dropdown-item>
                                <el-dropdown-item @click.native="multiRemarkEdit(idStr)">批量修改备注</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <el-dropdown>
                            <el-button icon="el-icon-my-daochu" type="info">导出简历<i class="el-icon-caret-bottom el-icon--right"></i></el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native="exportFiles(idStr)">导出已选记录(excel)</el-dropdown-item>
                                <el-dropdown-item @click.native="exportFiles(idStr, undefined, undefined, 'type=HTML')">导出已选记录(html)</el-dropdown-item>
                                <el-dropdown-item @click.native="exportParamsFiles('/payment/exportAllResume.api')">导出所有查询结果(excel)</el-dropdown-item>
                                <el-dropdown-item @click.native="exportParamsFiles('/payment/exportAllResume.api', 'HTML')">导出所有查询结果(html)</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <export-custom-dialog :valid-call-back="customExportValid" :params-call-back="customExportParams" class="ml-10"></export-custom-dialog>
                    </el-col>
                    <el-col >
                        <el-row v-if="lists.length" type="flex" justify="end">
                            <el-button @click="modifySalary(multipleSelection)" icon="" type="success" :plain="true">定薪批量修改</el-button>
                            <el-button @click="arrangeSalary(multipleSelection)" icon="" type="success" :plain="true">定薪批量安排</el-button>
                            <el-button @click="changeStatus(idStr,'pass', null, '接受Offer')" icon="el-icon-my-queding color-success" type="success" :plain="true">接受Offer</el-button>
                            <!--<el-button @click="changeStatus(idStr,'undetermined', null, '待定')" icon="el-icon-my-daiding color-warning" type="danger" :plain="true">待定</el-button>-->
                            <el-button @click="changeStatus(idStr,'fq', null, '放弃Offer')" icon="el-icon-my-guanbi color-danger" type="danger" :plain="true">放弃Offer</el-button>
                            <el-button @click="changeStatus(idStr,'back', null, '回退')" icon="el-icon-my-huitui color-info" type="danger" :plain="true">回退</el-button>
                            <el-button @click="changeStatus(idStr,'lh', null, '拉黑')" icon="el-icon-my-lahei color-purple" type="danger" :plain="true">拉黑</el-button>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
            <div v-loading="partialLoading">
                <empty-tip :show="!lists.length"></empty-tip>
                <div class="table-list mt-20">
                    <el-table v-if="lists.length"
                              ref="table"
                              :data="lists"
                              :default-sort="defaultSort"
                              @selection-change="handleSelectionChange"
                              @sort-change="handleChangeSort"
                    >
                        <el-table-column
                                type="selection"
                                align="center"
                                width="50">
                        </el-table-column>
                        <el-table-column
                                label="姓名"
                                fixed
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="80">
                            <template slot-scope="scope">
                                <span class="name-txt" @click="toResumeDetail(scope.row)">
                                    {{ scope.row.resumeForm.name }}
                                    <i
                                        style="transform: scale(.7)"
                                        :class="{
                                            'el-icon-my-nan': scope.row.resumeForm.gender === 1,
                                            'el-icon-my-nv color-danger': scope.row.resumeForm.gender === 2
                                        }"
                                    />
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="resumeForm.gender"
                                label="性别"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="80">
                            <template slot-scope="scope">{{{1: '男', 2: '女'}[scope.row.resumeForm.gender] || '-'}}</template>
                        </el-table-column>
                        <el-table-column
                                label="岗位"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{ scope.row.positionForm.name }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="招聘部门"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{ scope.row.positionForm.deptNames }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="resumeForm.mobilePhone"
                                label="手机号"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                        </el-table-column>
                        <el-table-column
                                prop="resumeForm.email"
                                label="邮箱"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                        </el-table-column>
                        <el-table-column
                            label="最高学历"
                            align="center"
                            :show-overflow-tooltip="true"
                            min-width="80">
                            <template slot-scope="scope">
                                {{ getSelectMapText('WB_EDU_DEGREE', scope.row.resumeForm.resumeMaxEducation.degree) }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="最高学历学校"
                                align="center"
                                :show-overflow-tooltip="true"
                                min-width="100">
                            <template slot-scope="scope">
                                <el-tag type="primary" v-if="scope.row.resumeForm.schoolType ==='1'">985</el-tag>
                                <el-tag type="success" v-else-if="scope.row.resumeForm.schoolType ==='2'">211</el-tag>
                                {{ scope.row.resumeForm.resumeMaxEducation.school }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="学校档位"
                                align="center"
                                :show-overflow-tooltip="true"
                                min-width="100">
                            <template slot-scope="scope">
                                {{ scope.row.resumeForm.resumeMaxEducation.sLevel }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="resumeForm.resumeMaxEducation.major"
                                label="专业"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="140">
                        </el-table-column>
                        <el-table-column
                                prop="resumeForm.origin"
                                label="籍贯"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="140">
                        </el-table-column>
                        <el-table-column
                                label="简历来源"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="90">
                            <template slot-scope="scope">
                                {{ getSelectMapText('WB_RESUME_SOURCE', scope.row.resumeForm.resumeSource)}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label='当前所在地'
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{ scope.row.resumeForm.residence || '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="应聘城市"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="80">
                            <template slot-scope="scope">
                                {{ getSelectMapText('WB_POSITION_CITY', scope.row.resumeForm.expectCityId)}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="positionForm.sourceFrom"
                                label="投递渠道"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{scope.row.resumeForm && getSelectMapText('WB_ADD_SOURCE',
                                scope.row.resumeForm.addSource)}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="投递人"
                                prop="resumeForm.addName"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="80">
                        </el-table-column>
                        <el-table-column
                                label="推荐人"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="80">
                            <template slot-scope="scope">
                                <span v-if="scope.row.resumeForm.recommenderUser">{{scope.row.resumeForm.recommenderUser.name}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="游戏经验"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{ scope.row.resumeForm.gameExperience }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="简历附件"
                                align="center"
                                min-width="120">
                            <template slot-scope="scope">
                                <attach-view-in-list :attachList="scope.row.resumeForm.resumeAttachList"></attach-view-in-list>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="投递时间" :show-overflow-tooltip="true" min-width="100" prop="commitTime" sortable="custom">
                            <template slot-scope="scope">{{dateFormat(scope.row.commitTime)}}</template>
                        </el-table-column>
                        <el-table-column align="center" label="面试评分" :show-overflow-tooltip="true" min-width="100">
                            <template slot-scope="scope"><span v-if="scope.row.evaluationForm">{{scope.row.evaluationForm.grade || scope.row.evaluationForm.score}}</span></template>
                        </el-table-column>
                        <el-table-column align="center" label="综合评价" :show-overflow-tooltip="true" min-width="100">
                            <template slot-scope="scope"><span v-if="scope.row.evaluationForm">{{scope.row.evaluationForm.content}}</span></template>
                        </el-table-column>
                        <el-table-column align="center" label="建议方向" :show-overflow-tooltip="true" min-width="100">
                            <template slot-scope="scope"><span v-if="scope.row.evaluationForm">{{scope.row.evaluationForm.hireAdvice}}</span></template>
                        </el-table-column>
                        <el-table-column align="center" label="期望描述" :show-overflow-tooltip="true" min-width="100">
                            <template slot-scope="scope"><span v-if="scope.row.evaluationForm">{{scope.row.evaluationForm.expectSalary}}</span></template>
                        </el-table-column>
                        <el-table-column prop="resumeForm.expectSalary" align="center" label="期望薪资" :show-overflow-tooltip="true" min-width="100">
                            <template slot-scope="scope">
                                <salary-edit :id="scope.row.resumeForm.id" v-model="scope.row.resumeForm.expectSalary"></salary-edit>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="定级" :show-overflow-tooltip="true" min-width="100">
                            <template slot-scope="scope">{{scope.row.resumePayment.secLevel}}</template>
                        </el-table-column>
                        <el-table-column align="center" label="定薪" :show-overflow-tooltip="true" min-width="100">
                            <template slot-scope="scope">{{scope.row.resumePayment.paymentLevel}}</template>
                        </el-table-column>
                        <el-table-column align="center" label="定薪人" :show-overflow-tooltip="true" min-width="100">
                            <template slot-scope="scope">{{scope.row.paymentEvaluationForm.names}}</template>
                        </el-table-column>
                        <el-table-column align="center" label="定薪安排时间" :show-overflow-tooltip="true" min-width="120" prop="createTime" sortable="custom">
                            <template slot-scope="scope">{{dateFormat(scope.row.paymentEvaluationForm.createTime)}}</template>
                        </el-table-column>
                        <el-table-column
                                label="简历状态"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="130">
                            <template slot-scope="scope">
                                <el-tooltip effect="dark" :content="scope.row.operateReason" placement="top-start"
                                            v-if="scope.row.operateReason">
                                    <el-button type="text" icon="el-icon-my-xinxi">
                                    </el-button>
                                </el-tooltip>
                                {{getSelectMapText('WB_FLOW_STATUS', scope.row.status)}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="评估状态"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="130">
                            <template slot-scope="scope">
                                <span v-if="scope.row.paymentEvaluationForm">{{getSelectMapText('WB_EVALUATION_STATUS', scope.row.paymentEvaluationForm.status)}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="邮件通知"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="130">
                            <template slot-scope="scope">
                                <span>{{getSelectMapText('WB_SEND_STATUS', scope.row.paymentEmailStatus) || '未发送'}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="主管"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="130">
                            <template slot-scope="scope">
                                <span style="width:80px; width: 70px;display: inline-block;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: bottom;">{{scope.row.managerInfo ? scope.row.managerInfo.name : ''}}</span>
                                <i class="el-icon-my-bishi edit-salary-btn" @click="editManager(scope.row)"></i>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="同步供应商"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                <span>{{getSelectMapText('WB_SYNC_STATUS', scope.row.resumeForm.isSync)}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="操作"
                                fixed="right"
                                align="center"
                                class-name="no-wrap"
                                min-width="150">
                            <template slot-scope="scope">
                                <el-button type="text" @click="arrangeSalary(scope.row)" v-if="(scope.row.paymentEvaluationForm || {}).status !== 2">定薪安排</el-button>
                                <el-button type="text" @click="modifySalary(scope.row)">定薪修改</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column prop="resumeForm.remark" :show-overflow-tooltip="true" label="备注"
                                         align="center"
                                         min-width="120">
                            <template slot-scope="scope">
                                <remark-edit :id="scope.row.resumeForm.id" v-model="scope.row.resumeForm.remark"></remark-edit>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination
                        v-if="lists.length"
                        class="text-center mt-20 mb-20"
                        @size-change="pageSizeChange"
                        @current-change="pageIndexChange"
                        :current-page="pagination.pageIndex"
                        :page-size="pagination.pageSize"
                        :page-sizes="[20, 50, 100, 200]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="pagination.recordCounts">
                </el-pagination>
            </div>
        </div>
        <arrange-salary-dialog ref="arrangeSalaryDialog" @reload="fetchData"></arrange-salary-dialog>
        <modify-salary-dialog ref="modifySalaryDialog" @reload="fetchData"></modify-salary-dialog>
        <manager-edit-dialog ref="managerEditDialog" @reload="fetchData"></manager-edit-dialog>
        <salary-email-dialog ref="salaryEmailDialog" @reload="fetchData"></salary-email-dialog>
        <multi-remark-edit-dialog ref="multiRemarkEditDialog" @reload="fetchData"></multi-remark-edit-dialog>
    </div>
</template>
<script type="text/javascript">
    import QueryListExtend from 'components/queryListExtend'
    import selectMapMixin from 'mixins/selectMapMixin'
    import operationMixin from '../operation/operationMixin'
    import queryListMixin from '../operation/queryListMixin'
    import AttachViewInList from '../operation/attachViewInList'
    import ArrangeSalaryDialog from 'views/operation/arrangeSalaryDialog'
    import ModifySalaryDialog from 'views/operation/modifySalaryDialog'
    import { dateFormat } from 'modules/tools'
    import ArrangementTooltips from 'views/operation/arrangeTooltips'
    import RemarkEdit from '../operation/remarkEditDialog'
    import MultiRemarkEditDialog from '../operation/multiRemarkEditDialog.vue'
    import SalaryEdit from '../operation/salaryEditDialog'
    import MultiSearch from 'views/common/multiSearch'
    import SalaryEmailDialog from '../operation/salaryEmailDialog'
    import managerEditDialog from '../operation/managerEditDialog'

    export default {
        'extends': QueryListExtend,
        'mixins': [selectMapMixin, operationMixin, queryListMixin],
        data () {
            return {
                fetchUrl: '/payment/list.api',
                paymentMessageList: [],
                multiFields: [{
                    filter: 'WB_RESUME_STATUS_6',
                    label: '简历状态',
                    data: [],
                    mode: 'select',
                    name: 'statusSearch'
                }, {
                    filter: 'WB_PAYMENT_STATUS',
                    label: '定薪安排',
                    multiple: false,
                    data: '',
                    mode: 'select',
                    name: 'paymentStatusSearch'
                }, {
                    label: '定薪安排时间',
                    mode: 'daterange',
                    name: 'paymentDate',
                }, {
                    filter: 'WB_SYNC_STATUS',
                    label: '是否同步',
                    multiple: false,
                    data: '',
                    mode: 'select',
                    name: 'isSync'
                }, {
                    filter: 'WB_SEND_STATUS',
                    label: '邮件通知',
                    multiple: false,
                    data: '',
                    mode: 'select',
                    name: 'paymentEmailStatus'
                }],
                searchData: {
                    searchWord: null,
                    orderBy: null,
                    ascOrDesc: null,
                },
                defaultSort: undefined
            }
        },
        created () {
            const { orderBy: prop, ascOrDesc } = this.$route.query
            if (prop) {
                this.defaultSort = {
                    prop,
                    order: ascOrDesc ? ascOrDesc === 'desc' ? 'descending' : 'ascending' : null,
                }
            }
        },
        methods: {
            multiRemarkEdit(ids) {
                if (this.checkDataValid(ids)) {
                    let $target = this.$refs.multiRemarkEditDialog
                    let rids = this.lists
                        .filter(cv => {
                            return ids.indexOf(cv.id) > -1
                        })
                        .map(cv => {
                            return cv.resumeForm.id
                        })
                        .join(',')
                    $target && $target.show(rids)
                }
            },
            dateFormat (date, format = 'yyyy/MM/dd') {
                return dateFormat(date, format)
            },
            fetchCallback (res) {
                this.paymentMessageList = res.result.paymentMessageList
            },
            needToShowArrangetInfo (data) {
                return data.interviewArrangeForms && data.interviewArrangeForms.length && _.any(data.interviewArrangeForms, function (item) {
                    return !item.evaluationed
                })
            },
            sendEmail () {
                if (this.checkDataValid(this.multipleSelection)) {
                    this.$refs.salaryEmailDialog.show(this.multipleSelection)
                }
            },
            editManager(item) {
                this.$refs.managerEditDialog.show(item)
            },
            arrangeSalary (item) {
                console.log(item)
                if (Array.isArray(item)) {
                    if (this.checkDataValid(item)) {
                        if (item.length > 1) {
                            this.$refs.arrangeSalaryDialog.show(item, false, this.paymentMessageList)
                        } else {
                            this.$refs.arrangeSalaryDialog.show(item[0], true, this.paymentMessageList)
                        }
                    }
                } else {
                    this.$refs.arrangeSalaryDialog.show(item, true, this.paymentMessageList)
                }
            },
            modifySalary (item) {
                console.log(item)
                if (Array.isArray(item)) {
                    if (this.checkDataValid(item)) {
                        if (this.checkPaymentId(item)) {
                            this.$message({
                                message: '所选人员存在不同的定薪规则，不能批量修改！',
                                type: 'warning'
                            })
                            return
                        }
                        if (item.length > 1) {
                            this.$refs.modifySalaryDialog.show(item, false)
                        } else {
                            this.$refs.modifySalaryDialog.show(item[0], true)
                        }
                    }
                } else {
                    this.$refs.modifySalaryDialog.show(item, true)
                }
            },
            checkPaymentId(itemList) { // 检查是否存在不同的职位定薪规则
                return itemList.some(item => item.positionForm.paymentId !== itemList[0].positionForm.paymentId)
            },
            toResumeDetail (row) {
                let path = this.getResumeDetailUrl(row.id, row.status)

                let routeData = this.$router.resolve({ path })
                window.open(routeData.href, '_blank')
            },
            handleChangeSort(val) {
                const { prop: orderBy, order } = val
                const ascOrDesc = order ? order === 'descending' ? 'desc' : 'asc' : null
                this.searchData.orderBy = ascOrDesc ? orderBy : ''
                this.searchData.ascOrDesc = ascOrDesc
                this.defaultSort = undefined
            },
            handleClear() {
                this.handleChangeSort({})
                this.$refs.table && this.$refs.table.clearSort()
            }
        },
        components: { ArrangeSalaryDialog, ModifySalaryDialog, ArrangementTooltips, RemarkEdit, AttachViewInList, MultiSearch, SalaryEdit, SalaryEmailDialog, managerEditDialog, MultiRemarkEditDialog }
    }
</script>

<style lang="scss" scoped>
    .salary-search {
        /deep/ .el-form-item.label-paymentDate label {
            width: 100px!important;
        }
    }
</style>



// WEBPACK FOOTER //
// salaryList.vue?20903244